import { Meta } from '~/lib/api/smartsend/types';
import { LocalUnitsEntry } from '../consts/ItemMetaConstants';
import { LocalUnitsEntry as LocalUnitsEntryType, localUnitsEntryHasValues } from './DimensionUnits';

/** Reads the local-units entry (what the user typed, in their own unit system) from an item's Meta, if any. */
export function getLocalUnitsEntry(meta: Meta | undefined): LocalUnitsEntryType | undefined {
  const raw = meta?.[LocalUnitsEntry]?.Value;
  if (!raw) {
    return undefined;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
}

/** Writes the local-units entry onto an item's Meta (mutates the passed-in Meta). */
export function setLocalUnitsEntry(meta: Meta, localUnitsEntry: LocalUnitsEntryType): void {
  meta[LocalUnitsEntry] = { Value: JSON.stringify(localUnitsEntry), Type: 'String' };
}

/** Removes the local-units Meta record entirely, if present (mutates the passed-in Meta). */
export function deleteLocalUnitsEntry(meta: Meta): void {
  delete meta[LocalUnitsEntry];
}

/**
 * Reconciles an item's local-units Meta record with the current in-memory entry: writes it when it
 * carries real as-entered values, removes an existing record once it no longer does (e.g. cleared
 * back to metric), and otherwise leaves Meta untouched - so a metric parcel with no as-entered
 * history never gets a blank record taking up a row. This is the single place callers should use to
 * persist a local-units entry, rather than calling setLocalUnitsEntry directly.
 */
export function reconcileLocalUnitsEntry(meta: Meta, localUnitsEntry: LocalUnitsEntryType | undefined): void {
  if (localUnitsEntryHasValues(localUnitsEntry)) {
    setLocalUnitsEntry(meta, localUnitsEntry);
  } else if (meta[LocalUnitsEntry]) {
    deleteLocalUnitsEntry(meta);
  }
}
